import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CityModel } from 'src/app/models/city.model';
import { StateModel } from 'src/app/models/state.model';

@Component({
  selector: 'app-menu-cities',
  templateUrl: './menu-cities.component.html',
  styleUrls: ['./menu-cities.component.scss']
})
export class MenuCitiesComponent {
  public show: boolean = false;
  public states: StateModel[] = [];
  public selectedState = 'Qualquer Lugar';

  @Input()
  set selected(value: StateModel | null) {
    this.selectedState = value === null
      ? 'Qualquer Lugar'
      : value.name;
  }

  @Input() 
  set cities(values: CityModel[] | null) {
    this.states = (values ?? []).map(city => city.state)
      .filter((state, index, self) => 
        index === self.findIndex((s) => s.id === state.id)
      );
  }

  @Output() stateChanged = new EventEmitter<StateModel | null>();

  toggle(): void {
    this.show = !this.show;
  }

  selectState(state: StateModel | null) {
    this.toggle();
    if (state == null) {
      this.selectedState = 'Qualquer lugar';
    } else {
      this.selectedState = state.name;
    }
    this.stateChanged.emit(state);
  }
}
